import { ClientFileStatus, DangerousState } from '@/enum'
import {
  mdiAccountOff,
  mdiCameraOff,
  mdiCarBrakeAlert,
  mdiCellphone, mdiContentSave,
  mdiEthernetCableOff, mdiEye, mdiEyeOff,
  mdiFood,
  mdiSeatbelt,
  mdiSleep, mdiSmoking, mdiTrashCan
} from '@mdi/js'

export const dangerousStateIcons = () => ({
  [DangerousState.DISTRACTION]: mdiCarBrakeAlert,
  [DangerousState.DISTRACTION_NO_FACE]: mdiAccountOff,
  [DangerousState.DISTRACTION_NO_ATTENTION]: mdiEyeOff,
  [DangerousState.DROWSINESS]: mdiSleep,
  [DangerousState.BELT_NOT_FASTEN]: mdiSeatbelt,
  [DangerousState.YAWNING]: mdiSleep,
  [DangerousState.CAMERA_SABOTAGE]: mdiCameraOff,
  [DangerousState.CAMERA_OFF]: mdiEthernetCableOff,
  [DangerousState.CELLPHONE_USE]: mdiCellphone,
  [DangerousState.EATING]: mdiFood,
  [DangerousState.SMOKING]: mdiSmoking
})

export const requestsFilesIcons = {
  [ClientFileStatus.INCOMPLETE]: mdiEyeOff,
  [ClientFileStatus.REQUESTED]: mdiEye,
  [ClientFileStatus.SAVED]: mdiContentSave,
  [ClientFileStatus.LOST]: mdiTrashCan
}
